export default __webpack_public_path__ + "static/media/aurelian.9d559729.svg";